import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 18H4V8h24zm-13.135-5.036a1 1 0 0 1-.365 1.366 5 5 0 1 1 0-8.66.999.999 0 1 1-1 1.731 3 3 0 1 0 0 5.198 1 1 0 0 1 1.365.365m10 0a1 1 0 0 1-.365 1.366 5 5 0 1 1 0-8.66.999.999 0 1 1-1 1.731 3 3 0 1 0 0 5.198 1 1 0 0 1 1.365.365"
    />
  </svg>
);
const SvgIconClosedCaptioningOn = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconClosedCaptioningOn);
export default Memo;
